import { useCallback } from 'react';
import type { ModalProps } from 'antd';

import {
    PPA_SIM_RESET_CANCEL_BTN,
    PPA_SIM_RESET_CONFIRM_BTN,
    PPA_SIM_RESET_MODAL,
} from 'constants/ppaTestIds';

import {
    StyledResetInputsModal,
    StyledResetInputsModalBody,
} from './ResetInputsConfirmationModal.styles';

type ResetInputsConfirmationModalProps = {
    open: boolean;
    confirmLoading?: boolean;
    onCancel: () => void;
    onConfirm: () => void | Promise<void>;
};

const RESET_INPUTS_MODAL_BODY =
    "This clears all inputs in this scenario and restores values to baseline. This can't be undone.";

const ResetInputsConfirmationModal = ({
    open,
    confirmLoading = false,
    onCancel,
    onConfirm,
}: ResetInputsConfirmationModalProps) => {
    const handleOk = useCallback(() => onConfirm(), [onConfirm]);

    return (
        <StyledResetInputsModal
            className="price-simulator-v3-reset-inputs-modal"
            open={open}
            centered
            width={520}
            title="Reset all inputs?"
            okText="Reset"
            cancelText="Cancel"
            confirmLoading={confirmLoading}
            destroyOnClose
            maskClosable={!confirmLoading}
            closable={!confirmLoading}
            cancelButtonProps={
                {
                    disabled: confirmLoading,
                    'data-testid': PPA_SIM_RESET_CANCEL_BTN,
                } as ModalProps['cancelButtonProps']
            }
            okButtonProps={
                {
                    'data-testid': PPA_SIM_RESET_CONFIRM_BTN,
                } as ModalProps['okButtonProps']
            }
            modalRender={(modalNode) => (
                <div className="overflow-hidden rounded-[6px]" data-testid={PPA_SIM_RESET_MODAL}>
                    {modalNode}
                </div>
            )}
            onCancel={onCancel}
            onOk={handleOk}
        >
            <StyledResetInputsModalBody>{RESET_INPUTS_MODAL_BODY}</StyledResetInputsModalBody>
        </StyledResetInputsModal>
    );
};

export default ResetInputsConfirmationModal;
